const state = () => ({
  modalVisible: false,
  historyDate: null,
});

const getters = {
  modalVisible: (state: any, getters: any, rootState: any) => {
    return state.modalVisible;
  },
  historyDate: (state: any, getters: any, rootState: any) => {
    return state.historyDate;
  }
};

const actions = {
  async showModal({ commit, state }: any) {
    commit('setModal', true);
  },
  async hideModal({ commit, state }: any) {
    commit('setModal', false);
  },
  async setHistoryDate({ commit, state }: any, value: string) {
    commit('setHistoryDate', value);
  },
};

const mutations = {
  setModal(state: any, value: boolean) {
    state.modalVisible = value;
  },
  setHistoryDate(state: any, value: string) {
    state.historyDate = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
